const e = {
  // @ts-ignore
  DEEPRESEARCH: JSON.parse("true"),
  // @ts-ignore
  VOICE_INPUT: JSON.parse("true"),
  // @ts-ignore
  VOICE_MODE: JSON.parse("true"),
  // @ts-ignore
  INTEGRATIONS: JSON.parse("true"),
  // @ts-ignore
  PROMOCODES: JSON.parse("true")
};
export {
  e as FeatureFlags
};
